export const TABLE_HEADER_HEIGHT = 48;
export const CUSTOM_FILTER_EXTRA_WIDTH = 3;

export const TABLE_TYPES = Object.freeze( {
    ACTIVE: 'active-table',
    BASIC: 'basic',
    GROUPED: 'grouped',
    REPORTING: 'reporting',
    SCROLLING: 'scrolling',
    WIDGET: 'widget',
    WIDGET_WITH_SUBTITLE: 'widget-with-subtitle'
} );

export const reportsCustomGridOptions = {
    defaultColDef: {
        filter: false,
        sortable: false,
        suppressMenu: true,
    },
    suppressRowClickSelection: true,
};
